import {
  SHOW_DELETE_STORE_MODAL,
  DELETE_STORE,
} from 'actions/DeleteStore/actionTypes';

const initialState = {
  postStoreLoading: false,
  isShowDelModalStore: false,
  dataPost: {},
};

const showModalStore = (state, action) => {
  return {
    ...state,
    isShowDelModalStore: !state.isShowDelModalStore,
    dataPost: action.data,
  };
};
const deleteStore = (state, action) => {
  return {
    ...state,
    dataPost: action.data,
  };
};
const deleteStoreReducer = (state = initialState, action) => {
  switch (action.type) {
    case SHOW_DELETE_STORE_MODAL:
      return showModalStore(state, action);
    case DELETE_STORE:
      return deleteStore(state, action);
    default:
      return state;
  }
};

export default deleteStoreReducer;
